/**
 * Quick Answer Block — Componente GEO
 * Bloco factual padronizado no inicio de posts para citacao por IA.
 */

import type { QuickAnswerData } from '@/lib/geo-factories';
import { createQuickAnswerBlock } from '@/lib/geo-factories';
import { useTranslation } from '@/hooks/useTranslation';
import { useI18n } from '@/hooks/useI18n';

interface QuickAnswerBlockProps {
  data: QuickAnswerData;
}

export function QuickAnswerBlock({ data }: QuickAnswerBlockProps) {
  const { t } = useTranslation();
  const { lang } = useI18n();
  const block = createQuickAnswerBlock(data, lang);

  return (
    <div className="my-6 p-5 bg-sand-50 border-l-4 border-ocean rounded-r-lg">
      <h3 className="font-display text-lg text-warm-dark mb-3">{t('widget.quickAnswer.title')}</h3>
      <pre className="font-body text-sm text-warm-gray whitespace-pre-wrap leading-relaxed">
        {block}
      </pre>
    </div>
  );
}
